<template>
	<a href="javascript:;" @click="handlerClickEvent" class="btn" :style="style" :class="classes">
		<span v-if="waitTime>=60"><slot></slot></span>
		<span v-else>{{$t('default.Resend')}}({{waitTime}}s)</span>
	</a>
</template>
<script>
	let timeInterval = null;
	const md5 = require('js-md5');
	export default{
		name:"WdButton",
		props:['type','size','bordered','styles','to'],
		data(){
			return {
				style:{
				},
				classes:[],
				waitTime:60,
				emailSending:false,
				phoneSending:false
			}
		},
		methods:{
			handlerClickEvent(){
				const from = this.$route.query.from || '';
				if(this.to) this.$router.push({name: this.to ,query: {from: from}});
			},
			endWait(){
				this.waitTime = 60;
				clearInterval(timeInterval);
				timeInterval = null;
			},
			startWait(){
				if(timeInterval) {
					this.endWait();
				}
				timeInterval = setInterval(()=>{
					if(this.waitTime<1){
						this.waitTime = 60;
						clearInterval(timeInterval);
						timeInterval = null;
						return;
					}
					this.waitTime -=1;
				},1000);
			},
			async sendEmailCode(type,email){
				if(this.waitTime < 60 || this.emailSending) return;
				//var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
				var reg = new RegExp("^[a-z0-9]+([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+");
				if(!email){
					this.$alert(this.$t("email.EmailTip"))
					return;
				}
				if(!reg.test(email.toLowerCase())){
					this.$alert(this.$t("email.EmailFormat"))
					return;
				}
				this.emailSending = true;
				let language = this.$i18n.locale;
				let response = await this.$api.post('/web/basic/sendEmailCode',{type:type,email:email,language});
				if(response.code != 0){
					if(response.code == 1010){
						this.$alert(this.$t('login.EmailHasReged'));
					}else if(response.code == -1){
						this.$alert(response.msg);
					}else{
						this.$alert(this.$t('default.ErrorSendingEmail'));
					}
					this.emailSending = false;
				}else{
					this.$alert(this.$t('default.SuccessSendingEmail'));
					this.startWait();
					this.emailSending = false;
				}
			},
			async sendMessageCode(type,phone){
				if(this.waitTime < 60 || this.phoneSending) return;
				if(!phone){
					this.$alert(this.$t("phone.MobilePhoneNumberTip"))
					return;
				}
				let regPhone = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
				if(this.$i18n.locale == 'zh' && !regPhone.test(phone)){
					this.$alert('手机号格式不正确');
					return;
				}
				this.phoneSending = true;
				let postData = {
					type:type,
					phone:phone,
					language:this.$i18n.locale,
					sign:md5(phone+'|'+type+'|'+this.$i18n.locale+'|wizard-member-client-message-code')
				}
				let response = await this.$api.post('/web/basic/sendMessageCode',postData);
				if(response.code != 0){
					if(response.code == -1){
						this.$alert(response.msg);
					}else{
						this.$alert(this.$t('default.ErrorSendingMessage'));
					}
					this.phoneSending = false;
				}else{
					this.$alert(this.$t('default.SuccessSendingMessage'));
					this.startWait();
					this.phoneSending = false;
				}
			}
		},
		created(){
			if(this.type){
				this.classes.push(this.type);
			}
			if(this.bordered){
				this.classes.push('bordered');
			}
			if(this.size){
				this.classes.push(this.size);
			}else{
				this.classes.push('medium');
			}
			if(this.styles) this.style = Object.assign({},this.style,this.styles);
		},
		mounted(){

		}
	}
</script>
<style scoped>
.btn{
	box-sizing: border-box;
	display: inline-block;
	text-align: center;
}
.btn span{
	display: flex;
	justify-content: center;
	flex-direction: column;
	width: 100%;
	height: 100%;

}
.btn:hover{
	background-color: #ce292d;
	color: #fff;
	border:none;
	border-width: 0px;
}
.bordered{
	border: 1px solid #9e9e9e;
}
.danger{
	background-color: #ce292d;
	color: #fff;
}
.danger:hover{
	background-color: #b91317;
}
.info{
	background-color: #484e5d;
	color:#fff;
}
.mini{
	font-size: 12px;
	border-radius: 2px;
	padding: 2px 5px;
}
.small{
	font-size: 14px;
	border-radius: 3px;
	padding: 5px 8px;
}
.medium{
	font-size: 16px;
	border-radius: 4px;
	padding: 8px 12px;
}
.large{
	font-size: 18px;
	border-radius: 5px;
	padding: 12px 20px;
}
</style>